import React from 'react'
import AboutHero from '../components/AboutHero/AboutHero'
import BlogFilterSection from '../components/BlogFilterSection/BlogFilterSection'
import BookingSection from '../components/BookingSection/BookingSection'
import Footer from '../components/Footer/Footer'
import { Helmet } from 'react-helmet'

const Insights = () => {
    return (
        <>
        <Helmet>
        <title>
        Elite Optix Insights | Eye Care Articles & Vision Tips
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://eliteoptix.com/insights"
        />
        <meta
          name="description"
          content="Explore Elite Optix Insights for expert articles on eye care, vision health, and eyewear trends. Stay informed and make smarter choices for your eyes."
        ></meta>
      </Helmet>
            <AboutHero page="insights" img={"/insights-hero.png"}
                title="Eye Care Knowledge at Your Fingertips"
                subtitle="Stay informed about the latest in eye health, vision technology, and eyewear trends. Elite Optix Insights help you make smarter choices for your eyes and style." />
            <div className='bg_gradient'>
                <BlogFilterSection />
                <BookingSection />
                <Footer />
            </div>
        </>
    )
}

export default Insights